import { useZodForm } from '../../../hooks/useZodForm.js';
import { schNewForm, schPairedSalesForm } from '../schemas.js';
import { InitialStudy } from '../types.js';

export const usePairedSalesForm = (defaultValues: InitialStudy['body']) => {
  return useZodForm({
    schema: schPairedSalesForm,
    defaultValues: schNewForm.parse(defaultValues),
    mode: 'onBlur',
    reValidateMode: 'onBlur',
  });
};
